import { breakpoints } from './breakpoints'

export const sizes = {
	container: {
		base: breakpoints.base,
		md: breakpoints.md,
		xl: breakpoints.xl
	}
}
